import { render, staticRenderFns } from "./VacancyCard.vue?vue&type=template&id=3079b43f&scoped=true&"
import script from "./VacancyCard.vue?vue&type=script&lang=ts&"
export * from "./VacancyCard.vue?vue&type=script&lang=ts&"
import style0 from "./VacancyCard.vue?vue&type=style&index=0&id=3079b43f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079b43f",
  null
  
)

export default component.exports